export class Microsoft365SourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryDomain",
            "baseName": "primaryDomain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365SourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
